const addCars = (data) => {
    return {
        type: "ADD_CARS_DATA",
        data
    }
}

export { addCars }